


























































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import catalogStore, { CatalogStoreModule } from '@/store/modules/catalog/module';
import { ScreenText } from '@/lang/ScreenText';
import { FilterListItem } from '@/Model/sessions/catalogTypes';
import AccountSettings from '@/mixins/accountSettings.mixin';
@Component
export default class CheckboxFilter extends Mixins(AccountSettings) {
  private screenText = new ScreenText();
  shouldDisplayFullFilterList: boolean = false;
  filterIdArray: Array<number> = [];

  @Prop({ type: String, default: '' }) filterTitle!: string;
  @Prop({ type: Array, default: () => [] }) filterList!: Array<FilterListItem>;
  @Prop({ type: String, default: '' }) filterEmptyText!: string;

  toggleFurtherDisplay() {
    this.shouldDisplayFullFilterList = !this.shouldDisplayFullFilterList;
  }

  get showMoreButtonText(): string {
    if (this.shouldDisplayFullFilterList) {
      return `${this.showFewerFiltersText}`;
    }
    const pre = this.screenText.getScreenText('CATALOG_SHOW');
    const post = this.screenText.getScreenText('CATALOG_MORE');
    return `${pre} ${this.remainingFilterOptionsList.length} ${post}`;
  }

  get showFewerFiltersText(): string {
    return this.screenText.getScreenText('CATALOG_SHOW_FEWER_FILTERS');
  }

  get initiallyDisplayedFilterOptions(): Array<FilterListItem> {
    return this.filterList.slice(0, CatalogStoreModule.initialFilterDisplayLength);
  }

  get remainingFilterOptionsList(): Array<FilterListItem> {
    if (this.filterList.length >= CatalogStoreModule.initialFilterDisplayLength) {
      return this.filterList.slice(CatalogStoreModule.initialFilterDisplayLength);
    }
    return [];
  }

  get isCheckboxDisabled(): boolean {
    return catalogStore.isFilterDisabled || catalogStore.isLoadingSessions;
  }

  get programFilterTitle(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_PROGRAMS');
  }

  get locationFilterTitle(): string {
    return this.screenText.getScreenText('CATALOG_FILTER_LOCATIONS');
  }

  updateFilterList($event: any, itemId: number) {
    this.$emit('change', this.filterList.find(x => x.id === itemId), $event.currentTarget.checked);
  }

  @Watch('filterList')
  onFilterListChange() {
    const filterItemsToRemove = this.filterList.filter(filterItem => filterItem.sessionIds.length === 0 && this.filterIdArray.includes(filterItem.id));
    const filterIdsToRemove = filterItemsToRemove.map(filterItem => filterItem.id);

    this.filterIdArray = this.filterIdArray.filter(id => !filterIdsToRemove.includes(id));
    filterItemsToRemove.forEach(filterItem => this.$emit('change', filterItem, false));
  }

  resetFilters() {
    this.filterIdArray = [];
  }
}
